<template>
<div class="booking-detail-right-side">
  <div class="guestlist" v-if="showGuestList">
    <div class="label f8">{{ $t('Host') }}</div>
    <div class="guests">
      <div class="guest">
        <div class="avatar f5">
          {{ initials(host) }}
        </div>
        <div class="contact">
          <div class="name f5">{{ host.firstName }} {{ host.lastName }}</div>
          <div class="email f7">{{ host.email }}</div>
        </div>
      </div>
    </div>
  </div>
  <BookingPrice v-if="isNetworkAvailable && !isOrganizationEducation" :bookingStationTimes="booking.bookingStationTimes" :locationId="locationId" v-on="$listeners" />
  <div class="notespreview" v-if="booking.notes">
    <div class="label f8">{{ $t('Notes') }}</div>
    <div class="f5 notescontent">{{ notesFormatted }}</div>
    <UIButton
      v-if="notesOverLimit"
      class="readmore"
      tiny
      @click="notesCollapsed = !notesCollapsed"
    >
      <template v-if="notesCollapsed">{{ $t('Read More') }}</template>
      <template v-else>{{ $t('Read Less') }}</template>
    </UIButton>
  </div>
  <UIButton
    v-if="waiversRequired"
    :ghost="true"
    class="sign-waivers"
    @click="openWaiverManager"
  >
    <i18n class="f4" path="Waivers ({remaining} remaining)">
      <template #remaining>{{ numRemainingWaivers }}</template>
    </i18n>
  </UIButton>
</div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import BookingPrice from '@/location/price-components/BookingPrice';
import UIButton from '@/core/shared/components/ui/UIButton';

@Component({
  props: {
    booking: {
      type: Object,
      required: true,
    },
    isNetworkAvailable: {
      type: Boolean,
      required: true,
    },
    locationId: {
      type: String,
      required: true,
    },
    isOrganizationEducation: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BookingPrice,
    UIButton,
  },
})
export default class BookingDetailRightSide extends Vue {
  notesCollapsed = true;

  get host () {
    return this.booking.host;
  }

  get numRemainingWaivers () {
    return this.booking.numPlayers - this.booking.waiverNumSigned;
  }

  get waiversRequired () {
    return this.booking.location.waiversRequired;
  }

  get showGuestList () {
    return this.booking.host && (
      this.booking.host.firstName ||
      this.booking.host.lastName ||
      this.booking.host.email ||
      this.booking.host.phone
    );
  }

  get notesOverLimit () {
    return this.booking.notes.length > 200;
  }

  get notesFormatted () {
    if (this.notesOverLimit && this.notesCollapsed) {
      return this.booking.notes.substring(0, 200);
    } else {
      return this.booking.notes;
    }
  }

  openWaiverManager () {
    if (this.isNetworkAvailable) {
      window.open('https://' + window.sbvrenv.CUSTOMER_URL + '/manage-waivers/operator/' + this.booking.waiverReferenceHost, '_blank');
    } else {

    }
  }

  initials (guest) {
    if (guest.firstName && guest.lastName) return guest.firstName.substr(0, 1) + guest.lastName.substr(0, 1);
  }
}
</script>

<style scoped lang="postcss">
@import 'core/shared/styles';

.booking-detail-right-side {
  display: grid;
  margin: var(--spacingMd) 0 0 0;
  grid-gap: var(--spacingSm);
  grid-auto-rows: min-content;

  @media (--tablet) {
    margin: 0;
  }

  & .label {
    color: var(--colorManatee);
  }

  & .guests {
      border-bottom: 0.1rem solid var(--colorCasper);

    & .guest {
      display: flex;
      padding: var(--spacingSm) 0;
      border-top: 0.1rem solid var(--colorCasper);
      align-items: center;

      & .avatar {
        margin: 0;
        padding: 0;
        text-align: center;
        line-height: 5rem;
        height: 5rem;
        width: 5rem;
        border-radius: 50%;
        background-color: var(--colorSlate);
        color: var(--colorWhite);
        margin-right: var(--spacingSm);
      }

      & .name {
        margin: 0;
      }

      & .email {
        margin: 0;
        color: var(--colorManatee);
      }
    }
  }

  & .notescontent {
    word-break: break-all;
  }

  & .editbooking {
    flex: 1 1 auto;
    margin-left: auto;
  }
}
</style>
